import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=5867974c&scoped=true&"
import script from "./Star.vue?vue&type=script&lang=js&"
export * from "./Star.vue?vue&type=script&lang=js&"
import style0 from "./Star.vue?vue&type=style&index=0&id=5867974c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867974c",
  null
  
)

export default component.exports